/**
 * Created by razial on 18.09.2026.
 */

const PassLevelsConfig = {};

cleverapps.EVENTS.PASS_FINISH_TASK = "pass_finish_task";
cleverapps.EVENTS.PASS_RECEIVED = "pass_received";
cleverapps.EVENTS.PASS_RECEIVED_PREMIUM = "pass_received_premium";
cleverapps.EVENTS.PASS_PURCHASED_TICKET = "pass_ticket_purchased";

Reward.register("battlePass", {
    bundle: "passbuyticket_window",

    getAnimation: function (value) {
        const mission = cleverapps.missionManager.findByType(value.missionType);

        return {
            json: mission && mission.isPassMission() ? mission.logic.getTicketJson() : bundles.passtickets.jsons.ticket_json,
            animation: "animation"
        };
    },

    getAmount: function (value) {
        return value.amount || 1;
    },

    getPrice: function (value) {
        return PassMissionLogic.GetHardPrice() * this.getAmount(value);
    },

    getText: function () {
        return Messages.get("PassProduct.Title");
    },

    receive: function () {
        return function () {};
    }
});

Placements.ENTRIES["displayPassWindow"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,
    filter: function () {
        const mission = cleverapps.missionManager.findLocalPass();
        return mission && mission.logic.needDisplayWindow() && !cleverapps.config.demoMode;
    },
    action: function () {
        const mission = cleverapps.missionManager.findLocalPass();

        if (mission.isRunning()) {
            mission.logic.displayWindow();
        } else {
            cleverapps.focusManager.display({
                focus: `missionCompleted${mission.name}`,
                action: function (f) {
                    mission.displayCompleted(f);
                }
            });
        }
    }
};
